<template lang="html">
    <div class="absolute z-30" :style="{ left: x + 'px', top: y + 'px', transform: 'rotate(' + rotate + 'deg)' }">
        <img class="h-52 max-w-none" :src="'/public/Calypso_Logo-' + no + '.svg'" alt="Calypso Mahieu">
    </div>
</template>

<script>
// import { mapState } from "vuex";
export default {
  data() {
    return {
        x: 0,
        y: 0,
        no: 0,
        rotate: 0,
    }
  },
  mounted() {
    this.x = Math.floor(Math.random() * ((window.innerWidth - 330) - 0 + 1)) + 0;
    this.y = Math.floor(Math.random() * ((window.innerHeight - 200) - 0 + 1)) + 0;
    this.no = Math.floor(Math.random() * (3 - 1 + 1)) + 1;
    var plusOrMinus = Math.random() < 0.5 ? -1 : 1;
    this.rotate = plusOrMinus * (Math.random() * 30);
  }
};
</script>
